import React from 'react'
import { Stack, Typography } from '@mui/material'

type Props = {
    label: string
    value: React.ReactNode
    valueColor?: string
    mono?: boolean
}

export default function DataRow({ label, value, valueColor, mono }: Props) {
    return (
        <Stack direction="row" justifyContent="space-between" alignItems="baseline" spacing={1}>
            <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0 }}>
                {label}
            </Typography>
            <Typography
                variant="body2"
                fontWeight={600}
                color={valueColor}
                textAlign="right"
                className={mono ? 'font-feature-num' : undefined}
                sx={{ minWidth: 0 }}
            >
                {value}
            </Typography>
        </Stack>
    )
}
